import React from 'react';
import { Wand2, Palette, Share2, Building2, Globe, Download } from 'lucide-react';

const ICONS = {
  Wand2,
  Palette,
  Share2,
  Building2,
  Globe,
  Download,
};

const SettingsTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="border-b border-dark-border mb-6">
      <nav className="-mb-px flex space-x-8 overflow-x-auto">
        {tabs.map((tab) => {
          const Icon = ICONS[tab.icon];
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap
                ${isActive
                  ? 'border-carmin text-carmin'
                  : 'border-transparent text-muted hover:text-primary hover:border-gray-500'
                }
              `}
            >
              {Icon && <Icon className="h-4 w-4" />}
              {tab.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default SettingsTabs;
